import Badges from './../requests/apa/Badges';
import getAppConfig from './../config/appConfig';
import AAF from 'src/AAF/AAF';
import store from 'src/store';

function getUserType(isLoggedIn, isSusc) {
  const isAdsEnable = AAF.AdsUtils.isAdsEnable();
  let userType = isAdsEnable ? 'freemium' : 'anonymous';

  if (isLoggedIn) {
    if (isAdsEnable) {
      userType = isSusc ? 'preemium' : 'freemium_registrado';
    } else {
      userType = isSusc ? 'susc' : 'no_susc';
    }
  }

  return userType;
}

function setBadgeType(type, groupId) {
  const linealChannels = store.getState().linealChannels;
  let badgeType = type;
    if (type && type === "live") {
      if (linealChannels && Array.isArray(linealChannels)) {
        const foundChannel = linealChannels.find(channel => channel.id == groupId);
        if (foundChannel) {
          badgeType = foundChannel.play ? "live_play1" : "live_play0";
        } else {
          badgeType = "live_play0";
        }
      } else {
        badgeType = "live_play0";
      }
    }
  return badgeType;
}

function getBadges(user, provider, format_types, live_enabled, groupId) {
  console.log('********[Badges] getBadges')
  if (!user || typeof provider === 'undefined' || typeof  format_types === 'undefined' || typeof live_enabled === 'undefined') {
    return '';
  }

  let badges = '';
  const config = getAppConfig();
  const userType = getUserType(user.isLoggedIn, user.isSusc);

  let formatTypes = (typeof format_types === 'object') ? format_types : format_types.split(',');

  if (formatTypes.length === 2 && formatTypes[0] === "est" && formatTypes[1] === "ppe") {
    formatTypes = formatTypes.reverse()
  }

  const type = live_enabled === '1' ? 'live' : 'vod';
  const badgeType = setBadgeType(type, groupId);

  if (provider === 'AMCO' || provider === 'amco') {
    provider = 'default';
  }

  if (Badges.data
    && Badges.data[userType]
    && Badges.data[userType][provider]
  ) {
    for (let i = 0; i < formatTypes.length; i++) {
      if (Badges.data[userType][provider][formatTypes[i]]
        && Badges.data[userType][provider][formatTypes[i]][badgeType]
      ) {
        const data = Badges.data[userType][provider][formatTypes[i]][badgeType];
        for (let i = 0; i < data.length; i++) {
          badges += data[i].render;
        }
      }
    }
  }

  return badges;
}

export default getBadges;



// WEBPACK FOOTER //
// ./src/utils/Badges.js